
















































































































import { IArticle } from "@/models/Article.model";
import { IMember } from "@/models/Member.model";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MemberTable extends Vue {
  get conference() {
    return this.$store.getters.getConferenceId;
  }
  @Prop()
  articles!: IArticle[];

  @Prop()
  reviewers!: IMember[];

  close() {
    const el = document.getElementById("modal");
    if (el) el.classList.remove("is-active");
  }

  get acceptedArticles() {
    return this.articles && this.articles.length > 0 && this.articles[0].status;
  }

  setReviewer(e: Event, article: IArticle) {
    // @ts-ignore
    article.reviewer = e.target.value;
    this.updateArticle(article);
  }

  async getExcelSheet() {
    window.open(
      `https://admin-nanomat.herokuapp.com/api/v1/excel/articles?conference=${this.conference}`
    );
  }

  updateArticle(article: IArticle) {
    this.$emit("updateArticle", article);
  }

  updateRole(article: IArticle) {
    this.$emit("updateRole", article._id, article.role);
  }

  compareString(m1: any, m2: any, prop: string) {
    if (m1[prop] && m2[prop]) {
      const s1 = m1[prop].toUpperCase();
      const s2 = m2[prop].toUpperCase();
      if (s1 == s2) return 0;
      if (s1 > s2) return 1;
      else return -1;
    } else return -1;
  }

  compareBool(m1: any, m2: any, prop: string) {
    const b1 = m1[prop];
    const b2 = m2[prop];
    if (b1 && b2) return 0;
    if (b1 && !b2) return -1;
    if (!b1 && !b2) return 0;
    if (!b1 && b2) return 1;
    return 0;
  }

  unsort() {
    Object.keys(this.sorted).forEach((key) => {
      this.sorted[key] = false;
    });
  }

  sorted: any = {
    firstName: false,
    lastName: false,
    email: false,
    topic: false,
    role: false,
    reviewer: false,
  };

  sortByFirstName() {
    if (this.sorted.firstName) {
      this.articles.sort((a, b) => this.compareString(b, a, "firstName"));
      this.unsort();
      this.sorted.firstName = false;
    } else {
      this.articles.sort((a, b) => this.compareString(a, b, "firstName"));
      this.unsort();
      this.sorted.firstName = true;
    }
  }

  sortByLastName() {
    if (this.sorted.lastName) {
      this.articles.sort((a, b) => this.compareString(b, a, "lastName"));
      this.unsort();
      this.sorted.lastName = false;
    } else {
      this.articles.sort((a, b) => this.compareString(a, b, "lastName"));
      this.unsort();
      this.sorted.lastName = true;
    }
  }

  sortByEmail() {
    if (this.sorted.email) {
      this.articles.sort((a, b) => this.compareString(b, a, "email"));
      this.unsort();
      this.sorted.email = false;
    } else {
      this.articles.sort((a, b) => this.compareString(a, b, "email"));
      this.unsort();
      this.sorted.email = true;
    }
  }

  sortByTitle() {
    if (this.sorted.title) {
      this.articles.sort((a, b) => this.compareString(b, a, "title"));
      this.unsort();
      this.sorted.title = false;
    } else {
      this.articles.sort((a, b) => this.compareString(a, b, "title"));
      this.unsort();
      this.sorted.title = true;
    }
  }

  sortByTopic() {
    if (this.sorted.topic) {
      this.articles.sort((a, b) =>
        this.compareString(b.topic, a.topic, "title")
      );
      this.unsort();
      this.sorted.topic = false;
    } else {
      this.articles.sort((a, b) =>
        this.compareString(a.topic, b.topic, "title")
      );
      this.unsort();
      this.sorted.topic = true;
    }
  }

  sortByRole() {
    if (this.sorted.role) {
      this.articles.sort((a, b) => this.compareString(b, a, "role"));
      this.unsort();
      this.sorted.role = false;
    } else {
      this.articles.sort((a, b) => this.compareString(a, b, "role"));
      this.unsort();
      this.sorted.role = true;
    }
  }

  sortByReviewer() {
    if (this.sorted.reviewer) {
      this.articles.sort((a, b) => this.compareString(b, a, "reviewer"));
      this.unsort();
      this.sorted.reviewer = false;
    } else {
      this.articles.sort((a, b) => this.compareString(a, b, "reviewer"));
      this.unsort();
      this.sorted.reviewer = true;
    }
  }
}
